<div *ngIf="isLoading" class="ui active inverted dimmer">
  <div class="ui dimmer loader"></div>
</div>


<div *ngIf="anObject.id && !anObject.isModified; else noObjectId"
     [formGroup]="formGroup"
     class="ui section">

  <ng-container *ngIf="!controlPoints?.length; else controlPointsExists">
    <sui-message class="info" [isDismissable]="false">
      <span>Контрольных точек еще нет. Можно их </span>
      <div *ngIf="patterns.length>1; else singlePattern"
           class="ui primary dropdown mini button" suiDropdown style="margin-left: 5px;">
        <div class="text">Создать</div>
        <i class="dropdown icon"></i>
        <div class="menu" suiDropdownMenu>
          <div *ngFor="let cpattern of patterns;" class="item" (click)="onCreateButton(cpattern.id)">
            {{cpattern.name}}
          </div>
        </div>
      </div>
      <ng-template #singlePattern>
        <div class="ui primary mini button" style="margin-left: 5px;"
             (click)="onCreateButton(patterns[0].id)">
          <div class="text">Создать</div>
        </div>
      </ng-template>
    </sui-message>
  </ng-container>

  <ng-template #controlPointsExists>
    <div class="fields" style="margin-bottom: 2px;">
      <div class="sixteen wide field">
        <div class="ui icon buttons right floated">
          <button class="ui button" (click)="regeneratePoints()">
            <i class="refresh icon"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="fields">
      <div class="sixteen wide field">
          <dx-grid
            [options]="controlPointsOptions"
            [rowClassRules]="rowHighlight"
            [data]="controlPoints"></dx-grid>
      </div>
    </div>
  </ng-template>
</div>


<ng-template #noObjectId>
  <sui-message class="info" [isDismissable]="false">
    <div class="header">
      Информация
    </div>
    <p>Нужно сохранить документ, прежде чем создавать контрольные точки</p>
  </sui-message>
</ng-template>
